import {
  BoundingBox2,
  BoundingBox2FromCenterSize,
} from './../../share/boundingbox2';
import { LineModel, FovModel } from './../../model';
import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Color, Vector2, Vector3 } from 'three';
import { filter, map, tap } from 'rxjs/operators';

export interface Models {
  Right: LineModel;
  Left: LineModel;
  Top: LineModel;
  Bottom: LineModel;
  Up: LineModel;
  Down: LineModel;
}

@Component({
  selector: 'ng3-fov',
  templateUrl: './fov.component.html',
  styleUrls: ['./fov.component.css'],
})
export class FovComponent implements OnInit {
  models$: Observable<Models>;
  lineTest = new LineModel(new Vector3(0, 0, 0), new Vector3(10, 10, 0));
  models: Models = {
    Right: this.lineTest,
    Left: this.lineTest,
    Top: this.lineTest,
    Bottom: this.lineTest,
    Up: this.lineTest,
    Down: this.lineTest,
  };
  public leftTop = new Vector3(0, 0, 0);
  public leftBottom = new Vector3(0, 10, 0);
  public rightTop = new Vector3(10, 0, 0);
  public rightBottom = new Vector3(10, 10, 0);
  public right = 10;
  public top = 20;
  public bottom = 10;
  public currentColor: Color = new Color(0.5, 0.5, 0.5);
  private boxSubject = new BehaviorSubject<BoundingBox2>(
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(1, 1)),
  );
  box$ = this.boxSubject.asObservable();

  private fovSubject = new BehaviorSubject<FovModel>(
    new FovModel(
      new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(60, 60)),
    ),
  );
  private fov$ = this.fovSubject.asObservable();

  // @Input()
  // get box(): BoundingBox2 {
  //   return this.boxSubject.value;
  // }

  // set box(b: BoundingBox2) {
  //   this.boxSubject.next(b);
  // }

  @Input()
  get model(): FovModel {
    return this.fovSubject.value;
  }
  set model(m: FovModel) {
    this.fovSubject.next(m);
  }

  @Input() z = 20;
  @Input() isActive = true;
  @Input() upAndDownShow = false;

  constructor() {
    this.models$ = this.fov$.pipe(
      filter(m => m !== undefined),
      map(m => this.addLines(m.box, true)),
    );
  }

  addLines(m: BoundingBox2, active: boolean = false) {
    if (m !== undefined) {
      this.setCurrentColor(active);
      this.setCurrentPos(m);
      this.models.Top = new LineModel(
        this.leftTop,
        this.rightTop,
        'Dashed',
        this.currentColor,
      );
      this.models.Bottom = new LineModel(
        this.leftBottom,
        this.rightBottom,
        'Dashed',
        this.currentColor,
      );
      this.models.Left = new LineModel(
        this.leftTop,
        this.leftBottom,
        'Dashed',
        this.currentColor,
      );
      this.models.Right = new LineModel(
        this.rightTop,
        this.rightBottom,
        'Dashed',
        this.currentColor,
      );
      this.models.Up = new LineModel(
        new Vector3(-1000, this.leftTop.y - 0.2, this.z),
        new Vector3(1000, this.leftTop.y - 0.2, this.z),
        'Dashed',
        new Color(1.0, 1.0, 0),
      );
      this.models.Down = new LineModel(
        new Vector3(-1000, this.leftBottom.y + 0.15, this.z),
        new Vector3(1000, this.leftBottom.y + 0.15, this.z),
        'Dashed',
        new Color(1.0, 1.0, 0),
      );
    }
    return this.models;
  }
  setCurrentColor(active: boolean = false) {
    if (active === true) {
      this.currentColor = new Color(1.0, 0.0, 0);
    } else {
      this.currentColor = new Color(0.5, 0.5, 0.5);
    }
  }
  setCurrentPos(m: BoundingBox2) {
    if (m !== undefined) {
      const left = m.center.x - m.size.x / 2;
      const right = m.center.x + m.size.x / 2;
      const top = m.center.y - m.size.y / 2;
      const bottom = m.center.y + m.size.y / 2;
      this.leftTop = new Vector3(left, top, this.z);
      this.leftBottom = new Vector3(left, bottom, this.z);
      this.rightTop = new Vector3(right, top, this.z);
      this.rightBottom = new Vector3(right, bottom, this.z);
    }
  }
  ngOnInit() {}
}
